import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetSelectedAd, selectedFBAdData } from "./FacebookAdsSlice";
import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

const ViewAdsDetails = ({ open, setOpen }) => {
  const userselectedFBAdData = useSelector(selectedFBAdData);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!open) dispatch(resetSelectedAd());
  }, [open]);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 lg:max-w-5xl sm:p-6">
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    onClick={() => setOpen(false)}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="my-3 border-2 rounded-lg p-2">
                  <div className="grid grid-cols-1 sm:grid-cols-2 p-3 gap-3 md:gap-5">
                    <img
                      src={userselectedFBAdData?.image_url}
                      alt={userselectedFBAdData?.title}
                      className="rounded-lg border-2 border-teal-400"
                    />
                    <div className="text-lg p-2">
                      <div className="font-semibold">
                        Ads Id:{" "}
                        <span className="text-sky-700">
                          {userselectedFBAdData?.id}
                        </span>
                      </div>
                      <div className="font-semibold">
                        Status:{" "}
                        <span className="text-teal-600">
                          {userselectedFBAdData?.status}
                        </span>
                      </div>
                      <h1 className="text-4xl my-2">
                        {userselectedFBAdData?.title}
                      </h1>
                      <div className="my-3">{userselectedFBAdData?.body}</div>
                    </div>
                  </div>
                </div>
                <button
                  className="mx-auto py-1.5 px-3 bg-red-500 rounded-md text-white grid place-content-center hover:cursor-pointer "
                  onClick={() => setOpen(false)}
                >
                  {" "}
                  Cancel
                </button>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ViewAdsDetails;
